import CheckboxInput from 'components/checkout/caap/CheckboxInput';
import styles from 'styles/components/checkout/caap/spc/imb.scss';

const Imb = componentParams => {
  const {
    headerText,
    onToggleShouldDefaultOptionsClick,
    shouldDefaultOptions,
    showImb
  } = componentParams;

  if (!showImb) {
    return null;
  }

  return (
    <div className={styles.imb}>
      <CheckboxInput
        clearAfter={true}
        header={headerText}
        isChecked={shouldDefaultOptions}
        onChange={onToggleShouldDefaultOptionsClick}
        name="shouldDefaultOptions">
        Check this box to default to these delivery and payment options in the future.
      </CheckboxInput>
    </div>
  );
};

export default Imb;
